
export default function useActions(
    user: Model.Response<Admin.Resources.User>, 
    api: Admin.Models.User.Api, 
    methods: Admin.Models.User.Methods
): Admin.Models.User.Actions {
   return { }
}